module.exports = __webpack_public_path__ + "static/media/icon_calendar02.405b7344.svg";